'use strict';

/**
 * View/Layout for create/edit object
 *
 * @category   View
 * @module     edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var ObjectModel = require('modules/collection/models/object');
var LayoutView = require('base/Colido.LayoutView');

//Component view
var ColorComponent = require('../components/field-colors');
var DimensionsComponent = require('../components/field-dimensions');
var EnumComponent = require('../components/field-enum');
var ScannersComponent = require('../components/field-scanners');
var WeightComponent = require('../components/field-weight');
var LengthComponent = require('../components/field-length');
var NumberComponent = require('../components/field-number');
var StringComponent = require('../components/field-string');
var TextComponent = require('../components/field-text');
var ImagesComponent = require('../components/field-images');
var AssetsComponent = require('../components/field-assets');
var MonetaryValueComponent = require('../components/field-monetary-value');
var StatusComponent = require('../components/field-status');
var LocalityComponent = require('../components/field-locality');
var SpeciesComponent = require('../components/field-species');
var HistoryComponent = require('../components/field-history');
var StorageComponent = require('../components/field-storage');
var SetsComponent = require('../components/field-sets');
var GroupComponent = require('../components/field-group');
//@addfield

var templates = {
    edit: require('modules/collection/modules/edit/templates/layout/edit.hbs'),
    create: require('modules/collection/modules/edit/templates/layout/create.hbs'),
};

var BaseLayout = LayoutView.extend({
    /**
     * Disable search
     * @type {boolean}
     */
    provideSearch: false,

    /**
     * Basic mode. Can be either 'create' or 'edit'
     * @type {string}
     */
    mode: 'create',

    /**
     * Set to true if model was saved successfully.
     */
    wasSaved: false,

    /**
     * Basic collection for the components
     * @type {Colido.Collection}
     */
    componentsCollection: null,

    /**
     * Filtered Collection of the components
     * @type {Colido.Collection}
     */
    filteredComponentsCollection: null,

    /**
     * Indicates the number of active image uploads
     * @type {number}
     */
    activeImageUploads: 0,

    /**
     * References for hidden fields
     */
    hiddenFields: [],

    fields: [],

    /**
     * Indicates, if the data has been changes
     * @type {boolean}
     */
    hasFormChanged: false,

    ui: function() {
        return {
            container: '.create-container',
            scrollContainer: '.scroll-container',
            form: 'form',
            inputField: 'input, textarea, button',
            targetStep: '[data-targetstep]',
            requiredFields: 'input[required]',
            submit: '[data-action="submit"]',
            inputWithLabel: '.input-label-group input',
            submitButtons: '.btn-submit-wrapper',
            showHiddenFields: '[data-action="show-hidden-fields"]',
            hideHiddenFields: '[data-action="hide-hidden-fields"]',
        };
    },

    events: function() {
        return {
            // Form actions
            'keyup input': 'checkInputWithLabel',
            'keyup textarea': 'checkInputWithLabel',
            'keydown input': 'checkInputWithLabel',
            'keydown textarea': 'checkInputWithLabel',
            'change @ui.requiredFields': 'checkRequired',
            'keyup @ui.requiredFields': 'checkRequired',
            'keydown @ui.requiredFields': 'checkRequired',
            'blur @ui.requiredFields': 'checkRequired',

            'focus @ui.inputField': 'focusInput',
            'change @ui.inputField': 'focusInput',
            'submit @ui.form': 'formSubmit',
            'reset @ui.form': 'formReset',
            'change @ui.form': 'formChanged',

            // Click actions
            'click @ui.submit': 'submitClicked',

            'click @ui.showHiddenFields': 'showHiddenFields',
            'click @ui.hideHiddenFields': 'hideHiddenFields',
            'focus input, textarea': 'onFocusInputField',
        };
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.fields = this.model.collection.catalog.getActiveEditFields();

        // this.loadComponents();
        // this.initializeComponents();
        this.listenTo(App.vent, 'photobox:images:selected', this.photoboxPicturesSelected.bind(this));

        $(window).on('beforeunload', this.handlePageUnload.bind(this));
    },

    getTemplate: function() {
        return templates[this.mode];
    },

    viewData: {
        catalogName: function() {
            return this.getOption('catalog').get('name');
        },

        fields: function() {
            return this.fields;
        },

        hiddenFields: function() {
            return this.hiddenFields;
        },

        editHeadline: function() {
            var headline = [];

            _.each(this.model.collection.catalog.get('fieldsEditHeadline'), function(fieldName){
                var fieldValue = this.model.get(fieldName);

                if (fieldValue) {
                    headline.push(fieldValue);
                }
            }.bind(this));

            return headline.join(' | ');
        },
    },

    getComponentView: function(field, options){
        options = _.extend({
            model: this.getOption('model'),
            field: field,
        }, options);

        if (this.components[field.type]) {
            return this.components[field.type].bind(this)(options);
        } else {
            console.warn('Missing editview component for field', field.name);

            return null;
        }
    },

    components: {
        string: function(options) {
            return new StringComponent(options);
        },

        text: function(options) {
            return new TextComponent(options);
        },

        enum: function(options) {
            return new EnumComponent(options);
        },

        colors: function(options) {
            return new ColorComponent(options);
        },

        datetime: function(options) {
        },

        weight: function(options) {
            return new WeightComponent(options);
        },

        length: function(options) {
            return new LengthComponent(options);
        },

        monetaryValue: function(options) {
            return new MonetaryValueComponent(options);
        },

        dimensions: function(options) {
            return new DimensionsComponent(options);
        },

        locality: function(options) {
            return new LocalityComponent(options);
        },

        images: function(options) {
            return new ImagesComponent(options);
        },

        assets: function(options) {
            return new AssetsComponent(options);
        },

        species: function(options) {
            return new SpeciesComponent(options);
        },

        sets: function(options) {
            return new SetsComponent(options);
        },

        storageId: function(options) {
            return new StorageComponent(options);
        },

        status: function(options) {
            return new StatusComponent(options);
        },

        history: function(options) {
            return new HistoryComponent(options);
        },

        group: function(options) {
            options = _.extend(options, {
                baseView: this,
            });

            return new GroupComponent(options);
        },

        scanners: function(options) {
            return new ScannersComponent(options);
        },

        number: function(options) {
            return new NumberComponent(options);
        },
        //@addfield
    },

    onRender: function() {
        var regions = {};

        _.each(this.fields, function(field){
            regions['field' + _.ucfirst(field.name) + 'Region'] = '.field-' + _.camelToHyphen(field.name) + '-region';
        })

        this.addRegions(regions);

        _.each(this.fields, function(field){
            var componentView = this.getComponentView(field);
            if (componentView) {
                this['field' + _.ucfirst(field.name) + 'Region'].show(componentView);
            }
        }.bind(this));
    },

    onAttach: function() {
        this.checkRequired();

        this.$('.component-is-hidden').each(function(index, element) {
            element = $(element);
            if (element.find('.has-value').length){
                $(element).removeClass('component-is-hidden');
            }
        });

        // Hiddens
        var hasHiddenFields = this.$('.component-is-hidden').length > 0;
        this.ui.container.toggleClass('has-hidden-fields', hasHiddenFields);

        // Handle filevent on whole container
        this.handleFileEvents();
    },

    onBeforeDestroy: function() {
        this.ui.container.off();
        $(window).off('beforeunload');
    },

    /**
     * Returns the component instance for the given ID
     * @param {string} id ID of the component
     * @returns {null}|{object}
     */
    getComponentInstance: function(id) {
        return this.filteredComponentsCollection.get(id).get('instance');
    },

    /**
     * Resets the layout and data
     * @param boolean render (Optional) Re-render components?
     */
    reset: function(render) {
        render = render || false;

        // Reset our object
        this.model.clear({silent: true});

        this.filteredComponentsCollection.each(function(component) {
            if (component.get('instance') && _.isFunction(component.get('instance').reset)) {
                component.get('instance').reset();
            }
        }.bind(this));

        // Reset form change state
        this.hasFormChanged = false;

        if (render) {
            this.filteredComponentsCollection.each(function(component) {
                if (component.get('instance') && _.isFunction(component.get('instance').render)) {
                    component.get('instance').render();
                }
            }.bind(this));
        }

        // Force required check
        this.checkRequired();
    },

    /**
     * Event for handling focus of input
     * @param {object} event The event object
     * @return {void}
     */
    focusInput: function(event) {
        $('.row').removeClass('help-active row-focused');
        $(event.currentTarget).parents('.row').addClass('help-active row-focused');
        if ($(event.currentTarget).parents('.create-step').attr('data-targetstep')) {
            var targetStep  = parseInt($(event.currentTarget).parents('.create-step').attr('data-targetstep'));
            var currentStep = parseInt(this.ui.container.attr('data-step'));

            if (targetStep > currentStep) {
                this.ui.container.attr('data-step', targetStep);
            }
        }
    },

    /**
     * Is called, when a input or textarea field is focusses. We will scroll the inputfield into the view
     * @param {object} event The focus event
     */
    onFocusInputField: function(event) {
        var curTarget = $(event.currentTarget);
        if ($('html').hasClass('android')
            && (curTarget.parents('.modal-body').length > 0 || curTarget.parents('.scroll-container').length > 0)
        ) {
            var scrollContainerOffset = this.ui.scrollContainer.offset();
            var targetOffset = $(event.currentTarget).offset();

            var scrollPosition = targetOffset.top
                - scrollContainerOffset.top
                + this.ui.scrollContainer.scrollTop()
                - this.getPxSize(5);

            this.ui.scrollContainer.animate({scrollTop: scrollPosition}, 400);
        }
    },

    /**
     * is triggered when something in the form has been changed.
     * @param {object=} event The event object
     */
    formChanged: function(event) {
        this.hasFormChanged = true;
    },

    /**
     * Event for submitting the form
     * @param {object} event The event object
     * @return {void}
     */
    formReset: function(event) {
        event.preventDefault();
        /* Stub */
    },

    /**
     * Event for submitting the form
     * @param {object} event The event object
     * @return {void}
     */
    formSubmit: function(event) { /* Stub */ },

    /**
     * Submit was clicked, we activate the form submission
     * @param event
     */
    submitClicked: function(event) {
        if (!this.ui.submit.prop('disabled')) {
            this.setSubmitState(false, true);

            _.delay(function() {
                this.ui.form.submit();
            }.bind(this), 20);
        }
    },

    /**
     * Is called, when pictures have been selected from the photobox
     * @param {Array}       images The array with the images
     * @param {Object|null} data   (Optional) Data from selection
     * @private
     */
    photoboxPicturesSelected: function(images, data) {
        var component = this.getComponentInstance('RfidConnection');
        data = data || {};

        if (component && data.rfidEpc) {
            // Set rfid connection
            component.setRfidState(component.RFID_STATES.CONNECTED, {
                epc: data.rfidEpc,
                scanner: data.storage,
            });
        }
    },

    /**
     * Event for handling required fields
     * @return {void}
     */
    checkRequired: function() {
        var allFilledUp = true;

        this.$('input[required]').each(function(n, el) {
            if ($(el).val().length === 0) {
                allFilledUp = false;
            }
        }.bind(this));

        this.setSubmitState(allFilledUp && this.activeImageUploads === 0, false);
    },

    /**
     * Event for checking the label input group
     * @param {object} event The event object
     * @return {void}
     */
    checkInputWithLabel: function(event) {
        var $curTarget = $(event.currentTarget);
        $curTarget.parents('.input-label-group').toggleClass('has-value', $curTarget.val().length > 0);
    },

    /**
     * Enables/Disables the submit buttons
     * @param {boolean} state   The state to set
     * @param {boolean} loading Set loading state
     */
    setSubmitState: function(state, loading) {
        if (_.isUndefined(loading)) {
            loading = false;
        }

        this.ui.submit.prop('disabled', !state).toggleClass('is-loading', loading);

        if (this.ui.submitSimilar) {
            this.ui.submitSimilar.prop('disabled', !state).toggleClass('is-loading', loading);
        }
    },

    /**
     * Binds the relevant uploads events from the image upload
     * @param {EditModule.ImageSelectionComponent} instance Instance of the image selection component
     */
    bindImageSelectionUploadEvents: function(instance) {
        this.listenTo(instance, 'upload:started', this.onUploadStarted.bind(this));
        this.listenTo(instance, 'upload:completed', this.onUploadCompleted.bind(this));
        this.listenTo(instance, 'upload:error', this.onUploadError.bind(this));
        this.listenTo(instance, 'upload:abort', this.onUploadAbort.bind(this));
    },

    /**
     * Handler for the upload start event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} formData  Attache formdata of the upload
     */
    onUploadStarted: function(childView, model, formData) {
        this.activeImageUploads++;
        this.checkRequired();
    },

    /**
     * Handler for the upload completed event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} event     The original event
     */
    onUploadCompleted: function(childView, model, event) {
        this.activeImageUploads--;
        this.checkRequired();
    },

    /**
     * Handler for the upload error event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} event     The original event
     */
    onUploadError: function(childView, model, event) {
        this.activeImageUploads--;
        this.checkRequired();
    },

    /**
     * Handler for the upload abort event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} event     The original event
     */
    onUploadAbort: function(childView, model, event) {
        this.activeImageUploads--;
        this.checkRequired();
    },

    /**
     * Shows all hidden fields
     */
    showHiddenFields: function() {
        this.ui.container.toggleClass('hidden-fields-active', true);

        // Check textareas
        this.fixTextareaSize(this.ui.container.find('textarea[data-autosize="true"]'))
    },

    /**
     * Hides all to hide fields
     */
    hideHiddenFields: function() {
        this.ui.container.toggleClass('hidden-fields-active', false);
    },

    handleFileEvents: function() {
        this.handleDragEnter = this.handleDragEnter.bind(this);
        this.handleDragOver  = this.handleDragOver.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDrop      = this.handleDrop.bind(this);
        this.ui.container.on('dragenter', this.handleDragEnter);
        this.ui.container.on('dragover', this.handleDragOver);
        this.ui.container.on('dragleave', this.handleDragLeave);
        this.ui.container.on('drop', this.handleDrop);
    },

    //@todo Handle drag and drop for multiple asset upload views

    /**
     * Handler for a drag enter event
     * @param {Object} event The event object
     */
    handleDragEnter: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.ui.container.addClass('has-files-over');

        if (event.originalEvent && event.originalEvent.dataTransfer) {
            event.originalEvent.dataTransfer.dropEffect = 'copy';
        }
    },

    /**
     * Handler for a drag over event
     * @param {Object} event The event object
     */
    handleDragOver: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.ui.container.addClass('has-files-over');

        if (event.originalEvent && event.originalEvent.dataTransfer) {
            event.originalEvent.dataTransfer.dropEffect = 'copy';
        }
    },

    /**
     * Handler for a drag over event
     * @param {Object} event The event object
     */
    handleDragLeave: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.ui.container.removeClass('has-files-over');
    },

    /**
     * Handler for a drop event
     * @param {Object} event The event object
     */
    handleDrop: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.ui.container.removeClass('has-files-over');

        var catalog = this.model.collection.catalog;
        var fields = catalog.get('fields');
        var uploadField = _.findWhere(fields, {displayType: 'images'}) || _.findWhere(fields, {displayType: 'assets'});

        if (uploadField && event.originalEvent && event.originalEvent.dataTransfer) {
            this.model.trigger('assetUpload', uploadField.name, event);
        }

        // // // Delegate event
        // var component = this.getComponentInstance('ImageSelection');
        // if (component && event.originalEvent && event.originalEvent.dataTransfer) {
        //     component.imageUploadView.$el.trigger('drop', event);
        // }
    },

    /**
     * Handles the unload event when user is in edit/create
     * @param {object} event The page unload event
     * @returns {*}
     */
    handlePageUnload: function(event) {
        if (!this.hasFormChanged || this.isDestroyed) {
            return undefined;
        }

        var confirmationMessage = App.t('collection::edit:message:unsaved-changes');
        (event || window.event).returnValue = confirmationMessage;

        return confirmationMessage;
    },

    /**
     * Indicates, if the modal can be destroyed
     * @returns {boolean} True, if the modal can be destroyed
     */
    canBeDestroyed: function() {
        if (this.wasSaved) {
            return true;
        }

        // Check unsaved changes
        if (this.hasFormChanged) {
            return window.confirm(App.t('collection::edit:message:unsaved-changes'));
        }

        return true;
    },

    getData: function() {
        var data = {};
        _.each(this.fields, function(field){
            var region = this['field' + _.ucfirst(field.name) + 'Region'];

            if (region && region.hasView()) {
                _.extend(data, region.currentView.getData());
            }
        }.bind(this));

        return data;
    },
});

module.exports = BaseLayout;